import { useState } from 'react';
import { useHistory } from 'react-router';

import { useIntegration } from '../useIntegration';
import { useActions } from '@mssgme/hooks';

export const ERROR_MESSAGES_MAP = {
    'errors.create_integration.viber.not_a_token': 'viberIntegration.errors.wrong_token',
};

export const useViberIntegration = ({ request }) => {
    const { api } = useActions();
    const { t, rootIntegrationsPath } = useIntegration();
    const history = useHistory();
    const [token, setToken] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await request(api.integrations.create({ payload: { type: 'viber', token } }));
            setToken('');
            history.push(rootIntegrationsPath);
        } catch (err) {
            // errors handled by request()
        }
    };

    return {
        t,
        handleSubmit,
        token,
        setToken,
    };
};
